module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-aure.181000a1.jpg";